import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { PanelType } from '@types';
import { $panel, $panelApi } from '@stores/panelStores';
import PanelUiColor from './PanelUIColor/PanelUIColor';
import PanelCopyright from './PanelCopyright/PanelCopyright';
import PanelEnterCover from './PanelEnterCover/PanelEnterCover';
import PanelCustomGroup from './PanelCustomButton/PanelCustomGroup';
import PanelCustomButton from './PanelCustomButton/PanelCustomButton';
import PanelStartAnime from './PanelStartAnime/PanelStartAnime';
import PanelCategoryConfig from './PanelCategoryConfig/PanelCategoryConfig';
import PanelTourTip from './PanelTourTip/PanelTourTip';
import PanelGlobal from './PanelGlobal/PanelGlobal';
import PanelLogo from './PanelLogo/PanelLogo';
import PanelLanguage from './PanelLanguage/PanelLanguage';
import PanelTourInfo from './PanelTourInfo/PanelTourInfo';
import { PanelEnterSandTable } from './PanelEnterSandTable';
import { PanelConfigLoading } from './PanelConfigLoading';
import { PanelSearchSetting } from './PanelSearchSetting';
import { PanelInteractive } from './PanelInteractive/PanelInteractive';
import PanelVipView from './PanelVipView/PanelVipView';

function PanelRootSettings() {
  const panel = useStore($panel);
  useEffect(() => {
    return () => {
      $panelApi.dismiss();
    };
  }, []);
  switch (panel.type) {
    case PanelType.info:
      return <PanelTourInfo />;
    case PanelType.enterCover:
      return <PanelEnterCover />;
    case PanelType.startAnime:
      return <PanelStartAnime />;
    case PanelType.tourTip:
      return <PanelTourTip />;
    case PanelType.categoryConfig:
      return <PanelCategoryConfig />;
    case PanelType.globalSettings:
      return <PanelGlobal />;
    case PanelType.logo:
      return <PanelLogo />;
    case PanelType.language:
      return <PanelLanguage />;
    case PanelType.customGroup:
      return (
        <PanelCustomGroup groupIndex={panel.groupIndex} isNew={panel.isNew} />
      );
    case PanelType.customButton:
      return (
        <PanelCustomButton
          groupIndex={panel.groupIndex}
          buttonIndex={panel.buttonIndex}
          isNew={panel.isNew}
        />
      );
    case PanelType.uiColor:
      return <PanelUiColor />;
    case PanelType.copyright:
      return <PanelCopyright />;
    case PanelType.sandTable:
      return <PanelEnterSandTable />;
    case PanelType.loading:
      return <PanelConfigLoading />;
    case PanelType.search:
      return <PanelSearchSetting />;
    case PanelType.interactive:
      return <PanelInteractive />;
    case PanelType.vipView:
      return <PanelVipView />;
    default:
      return null;
  }
}

export default PanelRootSettings;
